'use client';

import { useEffect } from 'react';
import CallAheadForm from '../../call-ahead/CallAheadForm';

// Disable static rendering so browser-only hooks run immediately
export const dynamic = 'force-dynamic';

export default function BrookfieldCallAhead() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Persist the location in both localStorage and a cookie so
      // subsequent requests (server-side or client-side) know which
      // restaurant this session pertains to.
      localStorage.setItem('restaurantLocation', 'Mimosa Brookfield');
      document.cookie = 'restaurantLocation=Mimosa Brookfield; path=/; max-age=31536000';

      // Monkey-patch fetch so every request automatically carries the
      // location header expected by our /api/proxy handler. This keeps us
      // from having to modify the massive CallAheadPage component.
      if (!(window as any).__locationFetchPatched) {
        const originalFetch = window.fetch.bind(window);
        window.fetch = (input: RequestInfo | URL, init: RequestInit = {}) => {
          const newInit: RequestInit = {
            ...init,
            headers: {
              ...(init.headers as any || {}),
              'X-Restaurant-Location': 'Mimosa Brookfield',
            },
          };
          return originalFetch(input, newInit);
        };
        (window as any).__locationFetchPatched = true;
      }
    }
  }, []);

  return <CallAheadForm />;
} 